import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-950">
      <div className="px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold font-heading text-accent-400">
                妖精动漫
              </span>
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed">
              精选无删减韩国漫画，下拉式阅读模式搭配免费韩漫大全，资源丰富、界面友好，操作简单便捷，让您轻松找到心仪的韩漫作品。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-secondary-100 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors">
                  分类浏览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-secondary-100 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-secondary-100 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5 text-sm text-secondary-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>contact@yaojingdongman.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400"></i>
                <span>韩国首尔特别市江南区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 妖精动漫 版权所有 | 韩国漫画 无删减漫画 下拉式漫画 免费韩漫大全
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-secondary-400 hover:text-accent-400 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-secondary-400 hover:text-accent-400 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-secondary-400 hover:text-accent-400 transition-colors" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}